import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllUserPaginated } from "../../api/userApi/userManagementReq";
import Pagination from "../../app/components/Pagination/Pagination";
import { toast } from "react-toastify";
import { GetSubscribers } from "../../api/userApi/registerEmailsApi";
import LoadingSpinner from "../../app/components/Loader/LoadingSpinner";

function NewsLetterSubscriber() {
  const navigate = useNavigate();

  const [subscriberList, setSubscriberList] = useState([]);
  const [PageNo, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const totalPages = Math.ceil(totalRows / pageSize);
  const [isLoading, setIsLoading] = useState(true);
  const tableRef = useRef(null);

  const navigateDashboard = () => navigate("/dashboard");

  const fetchSubscribers = async () => {

    const data = { PageNo, pageSize };
    try {
      const res = await GetSubscribers(data);
      if (res.result == 1) {
        setSubscriberList(res.result_value);
        setTotalRows(res.totalRows || 0);
        setIsLoading(false);
      } else if (res.result != 1) {
        toast.error("something went wrong! slow internet connection.");
      }
    } catch (error) {
      toast.error("Failed to fetch users.");
    }
  };

  useEffect(() => {
    fetchSubscribers();
  }, [PageNo, pageSize]);

  useEffect(() => {
    tableRef.current?.scrollTo({ top: 0, behavior: "smooth" });
  }, [PageNo, pageSize]);

  return (
    <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <div className="main-out-wraper">
       <div className="role-box">
        <h2 className="mb-0">Newsletter Subscribers</h2>
      </div>

      <div className="main_widget">
          <div className="main_widget_body">
            <div className="table-responsive" ref={tableRef}>
              <table>
                <thead>
                  <tr>
                    <th className="sn_th">S. No</th>
                    <th className="email_th">Email</th>
                    <th className="reg_th">Registration Time</th>
                  </tr>
                </thead>
                <tbody>
                  {subscriberList != null ? (
                    subscriberList.map((subscriber, index) => (
                      <tr key={subscriber.emailId}>
                        <td>{(PageNo - 1) * pageSize + index + 1}</td>
                        <td>{subscriber.emailAddress}</td>
                        <td>
                          {new Date(subscriber.registeredAt).toLocaleString(
                            "en-IN",
                            {
                              timeZone: "Asia/Kolkata",
                              year: "numeric",
                              month: "short",
                              day: "2-digit",
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                              hour12: true,
                            }
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <p>no subscriber found</p>
                  )}
                </tbody>
              </table>
            </div>
          </div>
      </div>

      <Pagination
      currentPage={PageNo}
      totalPages={totalPages}
      pageSize={pageSize}
      onPageChange={setPageNumber}
      onPageSizeChange={setPageSize}
      />
      </div>
    )}
    </>
  );
}

export default NewsLetterSubscriber;
